export default "__VITE_ASSET__BaFNnqcO__"